import { FIRST_LOAD_STATE_WAIT_MS } from 'projects/service/src/app/shared/utils/grid-persistence';
import { GridConfig, GridRow } from '@inavista/components/grid';
import { centreStatusColumns } from 'projects/service/src/app/shared/utils/grid-status-align';

// Service Order popup and ISC popup → Payment → the orders to consolidate on one invoice, on @inavista/components.
// Same checkbox column, columns, labels, order, widths, alignment, date format, status pill and toolbar as the
// Syncfusion grid it replaces. Rows: GET ServiceOrder/GetServiceOrdersForInvoicing (unchanged), served by
// LocalRowsGridApi. No paging (Martin): the grid scrolls.

export const PAYMENT_SELECTION_URL = 'page://payment-selection';
export const PAYMENT_SELECTION_PERSISTENCE_KEY = 'rims.service.payment-selection';

export const PAYMENT_SELECTION_COLUMNS: [string, string][] = [
  ['serviceOrderId', 'nvarchar'],
  ['serviceOrderIdLN', 'nvarchar'],
  ['status', 'nvarchar'],
  ['itemDescription', 'nvarchar'],
  ['startDate', 'datetime'],
  ['createdDate', 'datetime'],
  ['lastUpdatedDate', 'datetime'],
  ['callGroup', 'nvarchar'],
];

const ORDER = PAYMENT_SELECTION_COLUMNS.map(([c]) => c);
const DATE_FORMAT = 'd MMM, y';

export function buildPaymentSelectionGridConfig(statusColor: (value: unknown) => string, lockReason: (row: GridRow) => string | false): GridConfig {
  return centreStatusColumns({
    apiBaseUrl: PAYMENT_SELECTION_URL,
    clientSide: true,
    keyColumn: 'serviceOrderId',
    // 30, as the other Service Order popup grids.
    rowHeight: 30,
    // The old checkbox column (multi-select, checkbox only), 120 wide.
    selectable: true,
    selectColumnWidth: 120,
    // The checkboxes the old grid disabled: greyed, not clickable, (Select all) skips them (0.3.42, N79).
    rowCheckLockedFn: row => lockReason(row),
    defaultColumnOrder: ORDER,
    columnLabels: {
      serviceOrderId: 'Order No.', serviceOrderIdLN: 'LN Order No.', status: 'Status', itemDescription: 'Item/Object',
      startDate: 'Start Date', createdDate: 'Created Date', lastUpdatedDate: 'Last Updated Date', callGroup: 'Call Group',
    },
    // Every column left, as the old grid.
    columnAlign: Object.fromEntries(ORDER.map(c => [c, { horizontal: 'left' as const, header: { horizontal: 'left' as const } }])),
    // The old widths, all fixed: wider than the popup, so it scrolls sideways as before.
    columnWidths: {
      serviceOrderId: 120, serviceOrderIdLN: 120, status: 180, itemDescription: 150,
      startDate: 140, createdDate: 160, lastUpdatedDate: 160, callGroup: 170,
    },
    stretchColumns: false,
    columnTypes: { startDate: 'date', createdDate: 'date', lastUpdatedDate: 'date' },
    columnDateFormats: { startDate: DATE_FORMAT, createdDate: DATE_FORMAT, lastUpdatedDate: DATE_FORMAT },
    // Status and Item/Object had the Excel (checkbox list) filter; the rest the menu filter.
    excelFilterColumns: ['status', 'itemDescription'],
    columnColors: { status: statusColor },
    // The old toolbar: Search and Clear filters only. No Columns picker, no Excel export (allowExcelExport was on
    // but no button ever showed). Reset layout is kept: it undoes the saved layout.
    enableExport: false,
    enableColumnsPicker: false,
    enableSavedViews: false,
    enableScrollButtons: false,
    enableFitColumns: false,
    enableResetLayout: true,
    enableRefresh: false,
    enableFooter: false,
    emptyStateMessage: 'No service orders to consolidate.',
    // Right-click a cell filters by its value (Martin, 2026-10-29: every grid that filters).
    enableContextMenuFilter: true,
    persistenceKey: PAYMENT_SELECTION_PERSISTENCE_KEY,
    firstLoadStateWaitMs: FIRST_LOAD_STATE_WAIT_MS,
  });
}
